// ✅ Modified React Checkout page with schema-matching fields and Razorpay integration

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { products } from "../mock/products";
import { OrderRoutes } from "../Api/Routes";
import toast, { Toaster } from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import pincodeData from "../mock/pincodes.json";
const Checkout = () => {
  const { id } = useParams();
  const [processingOrder, setProcessingOrder] = useState(false);

  useEffect(() => {
    if (id == 3 || id == 4) {
      window.location.href = "/Not-Found";
    }
  }, [id]);

  const productData = products.filter((p) => p.id === parseInt(id));

  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    zipcode: "",
    amount: productData[0].pp, // default or fetched from productId
    quantity: 1,
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const isValidIndianMobile = (phone) => {
    return /^[6-9]\d{9}$/.test(phone);
  };

  const getExtraFee = (qty) => {
    if (qty === 1) return 60;
    if (qty === 2) return 40;
    if (qty === 3) return 20;
    return 0;
  };

  const verifyPincode = (pincode) => {
    return pincodeData.some((item) => item.Pincode === pincode);
  };

  const handlePayment = async (e) => {
    if (form.productId === 3 || form.productId === 4) {
      toast.error("Product not available");
      return;
    } else {
      e.preventDefault();
      if (
        form.email === "" ||
        form.phone === "" ||
        form.address === "" ||
        form.zipcode === "" ||
        form.firstName === "" ||
        form.lastName === ""
      ) {
        toast.error("Please fill all the fields");
      } else {
        setProcessingOrder(true);

        const isValidPincode = verifyPincode(form.zipcode);
        console.log(verifyPincode(form.pincode));
        if (!isValidPincode) {
          toast.error(
            "Invalid PIN code, please enter a valid Indian postal code"
          );
          setProcessingOrder(false);
          return;
        }

        if (!isValidIndianMobile(form.phone)) {
          toast.error("Please enter a valid Indian mobile number");
          setProcessingOrder(false);
          return;
        }

        const basePrice = productData[0].pp;

        // Calculate extra fee based on quantity
        const extraFee = getExtraFee(parseInt(form.quantity));

        // Calculate total amount
        const totalAmount = basePrice * form.quantity + extraFee;

        const orderPayload = {
          userName: `${form.firstName} ${form.lastName}`,
          email: form.email,
          phone: form.phone,
          address: form.address,
          zipcode: form.zipcode,
          amount: totalAmount,
          quantity: form.quantity,
          productName: productData[0].title,
          productId: productData[0].id,
        };

        const res = await fetch(OrderRoutes.Create, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(orderPayload),
        });

        if (res.status !== 201) {
          toast.error("Something went wrong");
          setProcessingOrder(false);
        } else {
          const { orderId, amount } = await res.json();

          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY, // replace
            amount: amount,
            currency: "INR",
            name: productData[0].name,
            description: "Product Purchase",
            order_id: orderId,
            handler: async function (response) {
              await fetch(OrderRoutes.Success, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  orderId,
                  razorpayPaymentId: response.razorpay_payment_id,
                  razorpaySignature: response.razorpay_signature,
                }),
              });
              setProcessingOrder(false);
              navigate(`/Order-Success/${orderId}`);
            },
            prefill: {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              contact: form.phone,
            },
          };

          const rzp = new window.Razorpay(options);
          rzp.open();
        }
      }
    }
  };

  return (
    <>
      <div id="qodef-page-inner" className="qodef-content-grid">
        <main
          id="qodef-page-content"
          className="qodef-grid qodef-layout--template"
        >
          <div className="qodef-grid-inner clear">
            <div className="qodef-grid-item qodef-page-content-section qodef-col--12">
              <div className="woocommerce">
                <div className="woocommerce-notices-wrapper" />
                <div id="qodef-woo-page" className="qodef--checkout">
                  <form
                    onSubmit={handlePayment}
                    className="checkout woocommerce-checkout"
                    noValidate
                  >
                    <div className="col2-set" id="customer_details">
                      <div className="col-1">
                        <div className="woocommerce-billing-fields">
                          <h3>Billing details</h3>
                          <div className="woocommerce-billing-fields__field-wrapper">
                            <h5>
                              Please Note, If you order Less than 3 items, you
                              are respected to pay the delivery charges also
                            </h5>
                            <p className="form-row form-row-first validate-required">
                              <label>First name *</label>
                              <input
                                type="text"
                                name="firstName"
                                onChange={handleChange}
                                required
                              />
                            </p>
                            <p className="form-row form-row-last validate-required">
                              <label>Last name *</label>
                              <input
                                type="text"
                                name="lastName"
                                onChange={handleChange}
                                required
                              />
                            </p>
                            <p className="form-row form-row-wide">
                              <label>Email *</label>
                              <input
                                type="email"
                                name="email"
                                onChange={handleChange}
                                required
                              />
                            </p>
                            <p className="form-row form-row-wide">
                              <label>Phone *</label>
                              <input
                                type="number"
                                name="phone"
                                onChange={handleChange}
                                required
                              />
                            </p>
                            <p className="form-row form-row-wide">
                              <label>Address *</label>
                              <input
                                type="text"
                                name="address"
                                onChange={handleChange}
                                required
                              />
                            </p>
                            <p className="form-row form-row-wide">
                              <label>Zipcode *</label>
                              <input
                                type="text"
                                name="zipcode"
                                onChange={handleChange}
                                required
                              />
                            </p>
                            <p className="form-row form-row-wide">
                              <label>Quantity *</label>
                              <input
                                type="number"
                                name="quantity"
                                value={form.quantity}
                                onChange={handleChange}
                                min="1"
                                required
                              />
                            </p>
                            <p className="form-row form-row-wide">
                              <label>Amount (INR) *</label>
                              <input
                                type="number"
                                name="amount"
                                value={form.amount}
                                disabled
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <table border="1">
                      <thead>
                        <tr>
                          <th>Addon Charges</th>
                          <th>Charges</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1 Quantity</td>
                          <td>+60 Rs</td>
                        </tr>
                        <tr>
                          <td>2 Quantity</td>
                          <td>+40 Rs</td>
                        </tr>
                        <tr>
                          <td>3 Quantity</td>
                          <td>+20 Rs</td>
                        </tr>
                        <tr>
                          <td>More than 3 Quantity</td>
                          <td>+0 Rs</td>
                        </tr>
                      </tbody>
                    </table>
                    <div
                      id="order_review"
                      className="woocommerce-checkout-review-order"
                    >
                      <div
                        id="payment"
                        className="woocommerce-checkout-payment"
                      >
                        <div className="form-row place-order">
                          <button
                            type="submit"
                            className="button alt qodef-borders--added"
                            name="woocommerce_checkout_place_order"
                            id="place_order"
                            disabled={processingOrder}
                          >
                            {processingOrder ? (
                              <ClipLoader color="#000" />
                            ) : (
                              <> Place order</>
                            )}

                            <span className="qodef-m-border--top-left" />
                            <span className="qodef-m-border--bottom-right" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Toaster />
    </>
  );
};

export default Checkout;
